interface RankingItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  trend: 'up' | 'down' | 'new';
}

const rankingData: RankingItem[] = [
  { rank: 1, title: '庆余年2', category: '古装·剧情', heat: '986万', trend: 'up' },
  { rank: 2, title: '唐朝诡事录之西行', category: '古装·悬疑', heat: '872万', trend: 'up' },
  { rank: 3, title: '墨雨云间', category: '古装·爱情', heat: '815万', trend: 'new' },
  { rank: 4, title: '狂飙', category: '剧情·犯罪', heat: '763万', trend: 'up' },
  { rank: 5, title: '长相思2', category: '古装·神话', heat: '698万', trend: 'down' },
  { rank: 6, title: '大奉打更人', category: '古装·探案', heat: '654万', trend: 'new' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">热门榜单</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">实时热度</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-800/40 hover:bg-background-800/70 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer"
            >
              <div className={`flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-accent-500 text-background-950' :
                item.rank === 2 ? 'bg-primary-500/80 text-background-950' :
                item.rank === 3 ? 'bg-secondary-500/60 text-foreground-50' :
                'bg-background-700/50 text-foreground-400'
              }`}>
                {item.rank < 10 ? `0${item.rank}` : item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-100 group-hover:text-accent-400 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-sm font-semibold text-accent-500">{item.heat}</div>
                <div className="flex items-center justify-end gap-1 mt-0.5">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-green-400 text-xs"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400 text-xs"></i>}
                  {item.trend === 'new' && <span className="text-[10px] text-accent-400 bg-accent-500/15 px-1.5 py-0.5 rounded">NEW</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}